export function isPostcodeInRange({
  postcode,
  rangeString,
}: {
  postcode: string
  rangeString: string
}): boolean {
  const regex = /Postnummer (\d+)-(\d+)/
  const matches = rangeString.match(regex)

  if (!matches) {
    throw new Error('Invalid range string')
  }

  const start = Number(matches[1])
  const end = Number(matches[2])
  const postcodeNumber = Number(postcode)

  return postcodeNumber >= start && postcodeNumber <= end
}
